import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { HttpClientModule } from '@angular/common/http';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { NgxStripeModule } from 'ngx-stripe';
import { ToastrModule } from 'ngx-toastr';
import { OcrSrtEditPageComponent } from './ocr-srt-edit-page/ocr-srt-edit-page.component';
import { RouterModule } from '@angular/router';

import { CookieService } from 'ng2-cookies';
import { LoaderComponent } from './loader/loader.component';
import { PaymentDetailsComponent } from './payment-details/payment-details.component';
import { SharedModule } from './shared/shared.module';
import { ResetComponent } from './reset/reset.component';
import { EmailConfirmComponent } from './email-confirm/email-confirm.component';
import { FirstPasswordComponent } from './first-password/first-password.component';
import { TranlationService } from './tranlation.service';
import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        DashboardComponent,
        LoaderComponent,
        PaymentDetailsComponent,
        ResetComponent,
        EmailConfirmComponent,
        FirstPasswordComponent,
        OcrSrtEditPageComponent,
    ],
    imports: [
        BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        HttpClientModule,
        ReactiveFormsModule,
        FormsModule,
        AppRoutingModule,
        RouterModule,
        ToastrModule.forRoot(),
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        NgxStripeModule.forRoot(environment.stripe.publicKey),
        SharedModule,
        VgCoreModule,
        VgControlsModule,
        VgOverlayPlayModule,
        VgBufferingModule,
    ],

    providers: [CookieService, TranlationService],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
